import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, model, untracked } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { DecimalPlacesCustomPipe } from '../../../../@core/pipes';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';
import { numberToCurrencyString } from '../../../../@core/utils/helper';
import { DocumentLineItem, DocumentLineItemType, PriceSourceType } from '../../../../generated/generated-types';

export interface ItemPriceColumnArgs {
  decimalPlaces?: number;
}

@Component({
  selector: 'app-item-price-column',
  imports: [TooltipModule, DecimalPlacesCustomPipe, TranslatePipe, NgIf],
  templateUrl: './item-price-column.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemPriceColumnComponent {
  private i18nService = inject(I18nService);

  modelSig = model<DocumentLineItem>({} as DocumentLineItem);
  itemPriceSig = model<string>();
  /**
   * ViewContainerRefDirective assigns `instance.args = value`.
   */
  protected _argsSig = model<ItemPriceColumnArgs>({});
  get args(): typeof this._argsSig {
    return this._argsSig;
  }
  set args(value: ItemPriceColumnArgs) {
    this._argsSig.set(value ?? {});
  }
  priceOriginMap = {
    MANUALPRICE: this.i18nService.translate('documents.manual'),
    LIST: this.i18nService.translate('documents.list'),
    PRICELIST: this.i18nService.translate('documents.price-list'),
    CUSTOMERPRICE: this.i18nService.translate('documents.customer-price'),
  };

  DocumentLineItemType = DocumentLineItemType;

  PriceSourceType = PriceSourceType;


  showLineItemDiscountBreakdownSig = computed(
    () => !!(this.modelSig().discountPercentage || this.modelSig().discountPercentage2),
  );

  constructor(
    private i18n: I18nService,
  ) {
    effect(() => {
      const model = this.modelSig();
      const displayDecimalPlaces = this._argsSig()?.decimalPlaces ?? model?.decimalPlaces;
      if (model?.itemPrice !== null && model?.itemPrice !== undefined) {
        untracked(() => this.itemPriceSig.set(numberToCurrencyString(
          model.itemPrice,
          '',
          displayDecimalPlaces,
        )));
      }
    });
  }

  getPriceOrigin(priceOrigin: PriceSourceType) {
    return this.priceOriginMap[priceOrigin];
  }

}
